import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  z-index: 1;\n  position: absolute;\n  top: -10px;\n  height: 20px;\n  width: 100%;\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  background: rgba(0, 0, 0, 0);\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  justify: right;\n  align-self: center;\n  padding-right: 20px;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 0.3em;\n  color: ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  list-style-type: none;\n  display: flex;\n  position: relative;\n  padding-right: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  margin-left: 10px;\n  margin-right: 10px;\n  font-size: 14px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  height: 10px;\n  margin: 10px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-self: center;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font-weight: bold;\n  color: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-self: center;\n  margin-right: auto;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 10px 10px;\n  display: flex;\n  align-items: flex-end;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  padding: 5px;\n  justify-content: space-between;\n  border-radius: ", ";\n  cursor: default;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  padding: 5px;\n  justify-content: space-between;\n  border: none;\n  border-radius: ", ";\n  color: currentColor;\n  cursor: pointer;\n  background: none;\n  ", ";\n  &:hover {\n    ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  list-style-type: none;\n  padding: 0px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border-radius: ", ";\n  border-color: ", ";\n  border-width: ", ";\n  border-style: solid;\n  & > :nth-child(n + 2) {\n    border-top-color: ", ";\n    border-top-width: ", ";\n    border-top-style: solid;\n  }\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import styled from '../utils/styling/styled-components';
import { theme } from '../theme';
import { Bodytext } from '../Typography';
import { THICC_MENU, THICC_MENU_ITEM } from '../utils/testing/TestIDs';
export var Positions;

(function (Positions) {
  Positions["right"] = "right";
  Positions["left"] = "left";
  Positions["center"] = "center";
})(Positions || (Positions = {}));

var Container = styled.ul(_templateObject(), theme.borderRadius.large, theme.colors.ivory, function (props) {
  return props.hasBorder ? '1px' : '0px';
}, theme.colors.ivory, function (props) {
  return props.hasBorder ? '1px' : '0px';
}, function (props) {
  return props.margin && "margin: ".concat(props.margin);
}, function (props) {
  return props.boxShadow && "box-shadow: ".concat(props.boxShadow);
}, function (props) {
  return props.backgroundColor && "background-color: ".concat(props.backgroundColor);
});
var Button = styled.button(_templateObject2(), theme.borderRadius.large, function (props) {
  return props.backgroundColor && "background-color: ".concat(props.backgroundColor);
}, function (props) {
  return props.hoverBackgroundColor && "background-color: ".concat(props.hoverBackgroundColor);
});
var OptionInner = styled.div(_templateObject3(), theme.borderRadius.large);
var IconContainer = styled.div(_templateObject4());
var LabelContainer = styled.div(_templateObject5());
var LabelWithDescriptionLabelContainer = styled(LabelContainer)(_templateObject6());
var BoldText = styled(Bodytext)(_templateObject7(), theme.colors.slate);
var CTAContainer = styled.div(_templateObject8());
var StyledChevron = styled(AcornsIcon)(_templateObject9());
var Title = styled.div(_templateObject10(), theme.colors.white);
var MenuOption = styled.li(_templateObject11(), function (props) {
  return props.withChevron ? '0px' : '10px';
});
var LabelDescription = styled(Bodytext)(_templateObject12(), theme.colors.stone);
var SubText = styled(Bodytext)(_templateObject13());
var positions = {
  right: 'flex-end',
  left: 'flex-start',
  center: 'center'
};
var FloatingTitle = styled.div(_templateObject14(), function (props) {
  return positions[props.position];
});

var renderOptionContent = function renderOptionContent(title, icon, label, labelDescription, subText, withChevron) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(FloatingTitle, {
    position: title.position
  }, typeof title.content === 'string' ? /*#__PURE__*/React.createElement(Title, null, title.content) : title.content), /*#__PURE__*/React.createElement(IconContainer, null, icon), labelDescription ? /*#__PURE__*/React.createElement(LabelWithDescriptionLabelContainer, null, /*#__PURE__*/React.createElement(BoldText, null, label), /*#__PURE__*/React.createElement(LabelDescription, null, labelDescription)) : /*#__PURE__*/React.createElement(LabelContainer, null, /*#__PURE__*/React.createElement(Bodytext, null, label)), subText && /*#__PURE__*/React.createElement(SubText, null, subText), withChevron && /*#__PURE__*/React.createElement(CTAContainer, null, /*#__PURE__*/React.createElement(StyledChevron, {
    icon: AcornsIcon.Icon.ChevronRight
  })));
};

var ThiccMenu = function ThiccMenu(_ref) {
  var margin = _ref.margin,
      boxShadow = _ref.boxShadow,
      backgroundColor = _ref.backgroundColor,
      hoverBackgroundColor = _ref.hoverBackgroundColor,
      menuItems = _ref.menuItems,
      hasBorder = _ref.hasBorder,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Container, {
    boxShadow: boxShadow,
    className: className,
    "data-testid": THICC_MENU,
    hasBorder: hasBorder,
    margin: margin,
    backgroundColor: backgroundColor
  }, menuItems.map(function (_ref2) {
    var label = _ref2.label,
        labelDescription = _ref2.labelDescription,
        subText = _ref2.subText,
        action = _ref2.action,
        title = _ref2.title,
        icon = _ref2.icon,
        withChevron = _ref2.withChevron;
    return /*#__PURE__*/React.createElement(MenuOption, {
      key: label,
      withChevron: withChevron
    }, action ? /*#__PURE__*/React.createElement(Button, {
      "data-testid": THICC_MENU_ITEM,
      hoverBackgroundColor: hoverBackgroundColor,
      key: label,
      onClick: action.callback,
      backgroundColor: backgroundColor
    }, renderOptionContent(title, icon, label, labelDescription, subText, withChevron)) : /*#__PURE__*/React.createElement(OptionInner, {
      key: label,
      "data-testid": THICC_MENU_ITEM
    }, renderOptionContent(title, icon, label, labelDescription, subText, withChevron)));
  }));
};

export { ThiccMenu };